import { Component, EventEmitter, HostListener, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MyPosService } from 'src/app/services/apiclient/myPos/myPos.service';
import { ToolsService } from 'src/app/services/tools/tools.service';
declare var MyPOSEmbedded: any;
@Component({
  selector: 'app-my-pos-embedded-buttons',
  templateUrl: './my-pos-embedded-buttons.component.html',
  styleUrls: ['./my-pos-embedded-buttons.component.css']
})
export class MyPosEmbeddedButtonsComponent implements OnInit {



  @Input() amount: any;
  @Input() mypos_account: any;
  @Input() metadata_provenance: any;
  @Input() id_user: any;



  @Output() onSuccessEvent = new EventEmitter<any>();


  buttonApple = false;
  buttonGoogle = false;
  constructor(
    private MyPosService: MyPosService,
    private tools: ToolsService,
    public translate: TranslateService
  ) { }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes['mypos_account'] && changes['mypos_account'].currentValue) {
      this.createTokenSession();
    }



  }

  /**
* @description create Token Session for pay button
*/
  createTokenSession(data?: any) {

    let IPCPaymentSessionCreate = {

      "IPCmethod": "IPCPaymentSessionCreate",
      "IPCLanguage": "fr",
      "Amount": this.amount,
      "Currency": this.mypos_account.currency.shortname,
      "OrderID": this.mypos_account.my_order_id,
      "CartItems": 1,
      "Article_1": "online",
      "Quantity_1": 1,
      "Price_1": this.amount,
      "Currency_1": this.mypos_account.currency.shortname,
      "Amount_1": this.amount,
      "OutputFormat": "JSON",
      "IPCVersion": "1.4"

    }




    this.MyPosService.getTokenSessionCreateMypos(IPCPaymentSessionCreate, this.metadata_provenance, this.id_user, this.mypos_account.sandbox).subscribe((data_: any) => {
      if (data_ && data_.SessionCreate && data_.SessionCreate.StatusMsg == "Success") {


        //create button
        this.createPayButton(data_.SessionCreate.SessionToken, data_.NameMerchant);


      }

    });
  }


  /**
   * @description button apple or google pay
   */
  createPayButton(sessionToken: any, name_merchant: any) {





    //apple or google pay
    let that = this;
    if (sessionToken) {
      if (MyPOSEmbedded.IS_APPLE_PAY_AVAILABLE) {

        MyPOSEmbedded.createApplePayButton(
          'embeddedButtons_apple', //div tag ID
          sessionToken, //Received session token from IPCPaymentSessionCreate
          {
            isSandbox: this.mypos_account.sandbox, //Is sandbox env
            merchantName: name_merchant, //Custom Merchant name
            onSuccess: function (data: any) {
              //On payment success
              that.onSuccessEvent.emit(data);

            },

            onDecline: function (err: any) {
              console.error('err', err)
              //On payment Declined
              // console.error(err);
            }
          }
        ).then((sessionData: any) => {
          setTimeout(() => {
            let embeddedButtons_appleDiv: any = document.getElementById('embeddedButtons_apple')?.clientHeight;
            this.buttonApple = embeddedButtons_appleDiv && embeddedButtons_appleDiv > 20 ? true : false;
          }, 1000);
          //When button is loaded
        }).catch((err: any) => {
          //Catched error loading
          console.error(err);
        });
      }
      // else {
      MyPOSEmbedded.createGooglePayButton(
        'embeddedButtons_google', //div tag ID
        sessionToken, //Received session token from IPCPaymentSessionCreate

        {
          isSandbox: this.mypos_account.sandbox, //Is sandbox env

          onSuccess: function (data: any) {
           
            //On payment Success
            that.onSuccessEvent.emit(data);
          },

          onDecline: function (data: any) {
            let message = data && data.message && data.message.data && data.message.data.data && data.message.data.data.StatusMsg ?
              data.message.data.data.StatusMsg : this.translate.instant('credit_due.error_pay')
            that.tools.openSnackBar(message, "warn", 5000);
            //On payment Declined
            // console.error(data);
          }
        }
      ).then((sessionData: any) => {
        setTimeout(() => {
          let embeddedButtons_googleDiv: any = document.getElementById('embeddedButtons_google')?.clientHeight;
          this.buttonGoogle = embeddedButtons_googleDiv && embeddedButtons_googleDiv > 20 ? true : false;
        }, 1000);
        //When button is loaded
      }).catch((err: any) => {
        console.error('err', err)
        //Catched error loading
        console.error(err);
      });
    }
  }

  getStatusPayment() {
    let IPCGetPaymentStatus = {
      "IPCmethod": "IPCGetPaymentStatus",
      "OrderID": this.mypos_account.my_order_id,
      "OutputFormat": "JSON",
      "IPCVersion": "1.4"
    }
    this.MyPosService.getPaymentStatus(IPCGetPaymentStatus, this.metadata_provenance, this.id_user, this.mypos_account.sandbox).subscribe((data: any) => { });
  }
}
